import type { State } from '../../../state/reducers/types';
import { getCards, getVisibleCardIds } from '../../../state/selectors/cards';

export type BacklogCardCount = {
	cardsCount: number;
	visibleCardsCount: number;
};

export const getBacklogCardCount = (state: State): BacklogCardCount => ({
	cardsCount: Object.keys(getCards(state)).length,
	visibleCardsCount: getVisibleCardIds(state).length,
});
